<template>
  <div class="get-scheme" @click="handleClick">
    <div class="get-scheme_box">
      <div class="arrow-right-box">
        <svg-icon class-name="arrow-right-icon" icon-class="arrow-right" />
      </div>
      <span>{{ $t('navigation.getScheme') }}</span>
    </div>
  </div>
</template>

<script>
import { toSubmitUserInfo } from '@/router/components/jumpTo'
export default {
  name: 'GetScheme',
  methods: {
    handleClick() {
      if (this.$route.name !== 'SubmitUserInfo') {
        toSubmitUserInfo()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$NavItemColor: rgb(255, 255, 255);
$NavItemColorActive: rgb(175, 179, 186);
$ButtonBackColor: #980608;
;
@media screen and (max-width: 768px) {
  .get-scheme {
    color: $NavItemColor;
    font-size: 0.75rem;
    font-weight: bold;
    position: fixed;
    top: 70vh;
    right: 0vw;

    .get-scheme_box {
      box-shadow: inset 0 .3125rem 1.0125rem 0 #980608,
        inset 0 -.3125rem .5rem 0 #ffffff40,
        inset 0 -.125rem .125rem 0 #980608;
      background-color: rgb(0, 0, 0);
      border-radius: 10px;
      cursor: pointer;
      padding: 1rem 0.6rem 0.5rem 0.6rem;
      font-size: 0.8rem;
      line-height: 2rem;

      &:hover {
        background-color: #980608;
        ;
      }

      .arrow-right-icon {
        font-size: 1.6rem;
        color: $ButtonBackColor;
      }

      .arrow-right-box {
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 2rem;
        text-align: center;
        background-color: $NavItemColor;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        margin: 0 auto;
      }
    }
  }
}

@media screen and (min-width: 769px) {
  .get-scheme {
    color: $NavItemColor;
    font-size: 0.75rem;
    font-weight: bold;
    position: fixed;
    top: 70vh;
    right: -5vw;

    .get-scheme_box {
      box-shadow: inset 0 .3125rem 1.0125rem 0 #980608,
        inset 0 -.3125rem .5rem 0 #ffffff40,
        inset 0 -.125rem .125rem 0 #980608;
      background-color: rgb(0, 0, 0);
      border-radius: 10px;
      cursor: pointer;
      padding: 1rem 0.5rem 0 0.5rem;

      &:hover {
        background-color: #980608;
        ;
      }

      .arrow-right-icon {
        font-size: 1.3rem;
        color: $ButtonBackColor;
      }

      .arrow-right-box {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 2rem;
        text-align: center;
        line-height: 1.4rem;
        background-color: $NavItemColor;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        margin: 0 auto;
      }
    }
  }
}
</style>
